window.addEventListener('load', () => {
	// initRouter();
	registerSW();
});

async function registerSW() {
  if ('serviceWorker' in navigator) {
    try {
      const registration = await navigator.serviceWorker.register('./sw.js');
      
      // Listen for updates to the service worker
      if (registration.waiting) {
        notifyUpdate(registration);
      }

      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            notifyUpdate(registration);
          }
        });
      });
    } catch (e) {
      console.log('ServiceWorker registration failed. Sorry about that.', e);
    }
  } else {
    console.log('Your browser does not support ServiceWorker.');
  }
}

function notifyUpdate(registration) {
  const reload = confirm('A new version is available. Would you like to update?');
  if (reload) {
    registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    window.location.reload();
  }
}

import './slds/scss/index.scss';
import './components/slds-system.js';
import './views/router-outlet.js';
import './views/notify-view.js';
import './views/post-view.js';
import './views/login-view.js';
import './views/app-view.js';
import './views/tos-policies-view.js';
import './views/data-deletion-view.js';